import React, { useEffect } from 'react'

import useStorageState from 'reacticoon/view/hook/useStorageState'
import CadUsefulDataProvider from 'modules/cadUsefulData/CadUsefulDataProvider'
import CadFactionContext, { CAD_FACTION_STORAGE_KEY } from './CadFactionContextDefinition'

export function CadFactionProvider({ children }) {
  const [faction, setFaction] = useStorageState(CAD_FACTION_STORAGE_KEY, null)

	return (
		<CadFactionContext.Provider value={{ loggedInFaction: faction, setLoggedInFaction: setFaction }}>
			<CadUsefulDataProvider>
				{children}
			</CadUsefulDataProvider>
		</CadFactionContext.Provider>
	)
}

export default CadFactionContext